module.exports = __webpack_public_path__ + "img/4.cc657e92.png";